import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { ArgoConnectionKindEnum } from '@redviking/argonaut-util/types/db-enums/argo/connection_kind';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import type { NodeSpec } from './NodeSpec';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const mqttSubscribeNodeSpec: NodeSpec<NodeCfg<'mqttSubscribe'>> = {
    requiredSockets: [ 'topic' ],
    cfg: () => ({
        id: getUID(),
        disabled: false,
        kind: 'mqttSubscribe',
        width: 220,
        controlValues: {
            qos: 0,
            connectionId: '',
            autoSubscribe: true,
        },
    }),
    controls: nodeCfg => ({
        connectionId: defineControlOpts({
            cfg: {
                kind: 'connectionSelect',
                label: 'Connection',
                allowedConnectionKinds: [ ArgoConnectionKindEnum.MqttBroker ],
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.connectionId,
        }),
        autoSubscribe: defineControlOpts({
            cfg: { kind: 'boolean', label: 'Auto Subscribe' },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.autoSubscribe,
        }),
        qos: defineControlOpts({
            cfg: {
                items: [
                    { label: '0', value: 0 },
                    { label: '1', value: 1 },
                    { label: '2', value: 2 },
                ],
                kind: 'selection',
                label: 'QoS',
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.qos,
        }),
    }),
    inputs: nodeCfg => ({
        topic: {
            controlOpts: defineControlOpts({
                cfg: { kind: 'text' },
                on: { 'update:value': defaultControlUpdateValueHandler },
                enableWithConnectedSocket: false,
                value: nodeCfg.socketDefaults?.inputs?.topic || '',
            }),
            socket: 'string',
            label: 'Topic',
        },
        resubscribe: { socket: 'event', label: 'Resubscribe' },
    }),
    kindLabel: 'MQTT Subscribe',
    nodeCategory: 'connection',
    nodeSubCategory: 'MQTT',
    outputs: () => ({
        event: { socket: 'event', label: 'On Message' },
        payload: { socket: 'varValue', label: 'Payload' },
    }),
    validator: () => true,
};
